document.addEventListener("DOMContentLoaded", () => {
  const cards = document.querySelectorAll(".b-product-card");
  cards.forEach((card) => {
    card.querySelectorAll(".b-product-card--option").forEach((option) => {
      option.addEventListener("click", () => {
        card.dataset.option = option.dataset.value;
      });
    });

    let maxHeight = 0;
    const textHolder = card.querySelector(
      ".b-product-card--value-text--holder"
    );
    textHolder.querySelectorAll("p").forEach((p) => {
      if (Number(p.offsetHeight) > maxHeight) {
        maxHeight = Number(p.offsetHeight);
      }
    });

    if (maxHeight > 48) maxHeight = 48;

    textHolder.style.minHeight = (maxHeight == 0 ? 24 : maxHeight) + "px";
    textHolder.style.height = "100%";
  });
});
